import { createFileRoute } from "@tanstack/react-router";
import { MuranoLeksikonIndexPage } from "@/pages/MuranoLeksikonPage";
import { localizedHead, SITE_URL } from "@/lib/seo";
import { leksikonArticles } from "@/lib/murano-leksikon";

const TITLE = "Murano encyclopedia — vintage Murano glass explained | Farveladeland";
const DESC =
  "Everything we know about vintage Murano glass: techniques, makers, history and care. Learn Vetri, Mazzega, Seguso and sommerso.";

export const Route = createFileRoute("/en/murano/leksikon/")({
  head: () => {
    const local = localizedHead({ path: "/murano/leksikon", locale: "en" });
    const itemListLd = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Murano encyclopedia",
      itemListElement: leksikonArticles.map((a, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `${SITE_URL}/en/murano/leksikon/${a.slug}`,
        name: a.en.title,
      })),
    };
    return {
      meta: [
        { title: TITLE },
        { name: "description", content: DESC },
        { property: "og:title", content: TITLE },
        { property: "og:description", content: DESC },
        { property: "og:type", content: "website" },
        { property: "og:image", content: leksikonArticles[0].cover },
        ...local.meta,
      ],
      links: local.links,
      scripts: [
        { type: "application/ld+json", children: JSON.stringify(itemListLd) },
      ],
    };
  },
  component: () => <MuranoLeksikonIndexPage locale="en" />,
});
